import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import dashboardService from '../../services/dashboard.service.';

export const dashboard = createAsyncThunk('dashboardSlice/dashboard', async (params, thunkAPI) => {
  try {
    const data = await dashboardService.dashboardAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getEnquiry = createAsyncThunk('dashboardSlice/getEnquiry', async (params, thunkAPI) => {
  try {
    const data = await dashboardService.getEnquiryAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getPageList = createAsyncThunk('dashboardSlice/getPageList', async (thunkAPI) => {
  try {
    const data = await dashboardService.getStaticPagesAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteUser = createAsyncThunk('dashboardSlice/deletePage', async (params, thunkAPI) => {
  try {
    const data = await dashboardService.deletetUserAPI(params);
    console.log(data);
    return { response: data };
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getUserDetail = createAsyncThunk('dashboardSlice/getUserDetail', async (params, thunkAPI) => {
  try {
    const data = await dashboardService.deletetUserAPI(params);
    console.log(data);
    return { response: data };
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  dashboardData: null,
  enquiryList: [],
  staticPageList: []
};

const dashboardSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  extraReducers: {
    [dashboard.fulfilled]: (state, action) => {
      state.dashboardData = action.payload.data;
    },

    [getEnquiry.fulfilled]: (state, action) => {
      state.enquiryList = action.payload.data;
    },
    [getPageList.fulfilled]: (state, action) => {
      state.staticPageList = action.payload.data;
    },
    [getUserDetail.fulfilled]: (state, action) => {
      state.ownerData = action.payload.data;
    }
  }
});

const { reducer } = dashboardSlice;
export default reducer;
